/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import moment from 'moment-timezone';

/**
 * Format the timestamps to use in LiveChat and other chat sessions.
 *
 * @param {String} timestamp The timestamp string
 * @param {Bool} withHour Whether to include the hour next to the date
 * @param {String} timezone The timezone to use
 * @returns {String} Returns a formatted timestamp.
 */
export default function formatTimestamp(timestamp, withHour = false, timezone = 'UTC') {
  const hourFormat = withHour ? 'HH:mm' : '';

  // Apply the timezone
  moment.tz.setDefault(timezone);

  if (moment().isSame(timestamp, 'day')) {
    return moment(timestamp).format('HH:mm');
  } else if (moment().isSame(timestamp, 'week')) {
    return moment(timestamp).format(`ddd ${hourFormat}`);
  } else if (moment().isSame(timestamp, 'year')) {
    return moment(timestamp).format(`MMM DD ${hourFormat}`);
  } else if (moment().isAfter(timestamp, 'year')) {
    return moment(timestamp).format(`DD/MM/YY ${hourFormat}`);
  }
}
